import { lazy } from "react";

const CreateNotiCampaignPage = lazy(() => import("./create"));
const NotiCampaignListPage = lazy(() => import("./main"));
const UpdateNotiCampaignPage = lazy(() => import("./update"));

export {
  CreateNotiCampaignPage, NotiCampaignListPage, UpdateNotiCampaignPage,
};
